export default function updateActionCreators(resourceName, actionTypes, api) {
    let actionCreators = {

        update: function (id, data, auth, queryParams, shouldMergeData = true) {
            return function (dispatch) {
                dispatch(actionCreators.request());

                return api.update(id, data, auth, queryParams)
                    .then(
                        response => dispatch(response.errors ? actionCreators.failure(response.errors) : actionCreators.success(response, shouldMergeData)),
                        exception => dispatch(actionCreators.failure(exception))
                    ).then(
                        response => dispatch(actionCreators.complete(response)),
                        exception => dispatch(actionCreators.complete())
                    );
            }
        },

        request: function () {
            let name = resourceName + '_UPDATE_REQUEST';

            return {
                type: actionTypes[name]
            }
        },

        success: function (data, shouldMergeData) {
            let name = resourceName + '_UPDATE_SUCCESS';
            return {
                shouldMergeData: shouldMergeData,
                data: data,
                type: actionTypes[name]
            }
        },

        complete: function (data) {
            let name = resourceName + '_UPDATE_COMPLETE';
            return {
                data: data,
                type: actionTypes[name]
            }
        },

        failure: function (errors) {
            let name = resourceName + '_UPDATE_FAILURE';
            return {
                errors: errors,
                type: actionTypes[name]
            }
        }
    };

    return {
        update: actionCreators.update
    };
}